module.exports = __webpack_public_path__ + "img/yy.51c27af8.png";